module.exports = {
	"root": "findify-components--icon"
};